module.exports = __webpack_public_path__ + "static/img/internacional.7b602ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/internacional.png
// module id = POLe
// module chunks = 1